import { createFileRoute } from '@tanstack/react-router'
import { ProgressNoteTemplateEditorPage } from '@/features/organizations/settings/progress-note-templates/editor/template-editor-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/progress-note-templates/$templateId'
)({
  component: ProgressNoteTemplateEditorPage,
})
